module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-panel padded"
  }, [(_vm.currentOta) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.otaName))]), _vm._v(" INTEGRATIONS:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', [_c('span', [_vm._v("Allow to cancel bookings ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cancellationPolicy),
      expression: "cancellationPolicy"
    }],
    staticStyle: {
      "width": "65px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cancellationPolicy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cancellationPolicy = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("hour(s) or more before booked activity takes place.")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-red-pale p-2 my-3 fs-small"
  }, [_vm._v("\n                    The cancellation policy is agreed between the parties. When making changes make sure you and " + _vm._s(_vm.currentOta.name ? _vm.currentOta.name : 'your OTA') + " agree on the cancellation period set.\n                ")])])]), _vm._v(" "), (_vm.currentOta.integration) ? _c('div', {
    staticClass: "col-sm-12 mt-3"
  }, [_c('h5', [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.otaName))]), _vm._v(" INTEGRATIONs")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('div', {
    staticClass: "d-flex flex-grow-1"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.textSmall)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('a', {
    attrs: {
      "href": _vm.helpLink,
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "btn cancel wider"
  }, [_vm._v("Instructions Guide")])])])]), _vm._v(" "), _c(_vm.integrationComponent, {
    tag: "div",
    staticClass: "mt-3",
    attrs: {
      "ota": _vm.currentOta
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6ac80eb1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ac80eb1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentOtaSettings.vue
// module id = 1297
// module chunks = 0